module.exports = __webpack_public_path__ + "static/media/press_logo_forbes.76923667.jpg";